
import { findNearestExchangeRate } from './currency.js';
import { naturalCompare } from "./textparse.js";
import moment from 'moment';
import { getGeneralLedgerData } from './generalledger.js';

import { getAssetAccounts } from './assetaccounts.js';
import { getLiabilityAccounts } from './liabilityaccounts.js';
import { getSupplierAccounts } from './suppliers.js';
import { getCashAccounts } from './cashaccounts.js';
import { getEquityAccounts } from './equityaccounts.js';
import { getClientAccounts } from './clients.js';

export function getgeneralledgerreportdata(context) {
    const {
        currencies,
        exchangerates,
        selectedcurrencyid,
        fromts,
        tots,
    } = context;

    let result = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)

    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = 0; i < generalledgerdata.length; i++) {
        const item = generalledgerdata[i];

        let debit = 0;
        let credit = 0;

        let date = moment.unix(item.ts).format("D/MMM/YYYY");

        if (item.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrencyid).exchangerate;
            debit = Number(item.debit) * rate || 0;
            credit = Number(item.credit) * rate || 0;
        }
        else {
            debit = Number(item.debit) || 0;
            credit = Number(item.credit) || 0;
        }

        totalDebit = totalDebit + debit
        totalCredit = totalCredit + credit

        result.push({
            date: date,
            name: item.name,
            accounttype: item.accounttype,
            currency: currencySymbol,
            debit: debit,
            credit: credit,
            type: item.type,
            tabletype: 'item',
        });
    }

    result.push({
        name: 'Total',
        currency: currencySymbol,
        debit: totalDebit,
        credit: totalCredit,
        tabletype: 'sectiontotal',
    });

    return result;
}

export function getgeneralledgersummarydata(context) {
    const {
        currencies,
        exchangerates,
        selectedcurrencyid,
        fromts,
        tots,
    } = context;

    let result = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)

    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    let totaldebit = 0;
    let totalcredit = 0;
    let totalbalance = 0;

    const accounttypes = [...new Set(generalledgerdata.map(d => d.accounttype))];
    accounttypes.forEach(type => {
        let typedebit = 0;
        let typecredit = 0;
        let typebalance = 0;
        generalledgerdata
            .filter(data => data.accounttype == type)
            .map((data) => {
                let debit = parseFloat(data.debit) || 0;
                let credit = parseFloat(data.credit) || 0;

                if (data.currencyid !== selectedcurrencyid) {
                    const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                    debit = debit * rate;
                    credit = credit * rate;
                }
                typedebit = typedebit + debit
                typecredit = typecredit + credit
            })
        typebalance = typedebit - typecredit;

        totaldebit = totaldebit + typedebit
        totalcredit = totalcredit + typecredit
        totalbalance = totalbalance + typebalance

        result.push({
            name: type,
            debit: typedebit,
            credit: typecredit,
            balance: typebalance,
            currency: currencySymbol,
            type: 'item'
        })
    })

    result.push({
        name: 'Total',
        debit: totaldebit,
        credit: totalcredit,
        balance: totalbalance,
        currency: currencySymbol,
        type: 'sectiontotal'
    })

    return result;
}

export function getreceiptspaymentsreportdata(context) {
    const {
        currencies,
        exchangerates,
        selectedcurrencyid,
        selectedcashaccountid,
        fromts,
        tots,
    } = context;

    let result = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)
        .filter(data => data.accounttype == 'cashaccounts' && data.type != 'interaccounttransfers')
        .filter(data => data.accountid == selectedcashaccountid || !selectedcashaccountid)

    let currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    result.push({
        name: 'Receipts',
        tabletype: 'section',
    })

    let totalreceipts = 0;
    generalledgerdata
        .filter(data => data.debit > 0)
        .map((data) => {
            let debit = 0;

            let date = moment.unix(data.ts).format("D/MMM/YYYY");

            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                debit = Number(data.debit) * rate || 0;
            }
            else {
                debit = Number(data.debit) || 0;
            }
            totalreceipts = totalreceipts + debit
            result.push({
                date: date,
                name: data.name,
                accounttype: data.accounttype,
                currency: currencySymbol,
                amount: debit,
                tabletype: 'item',
            })
        })

    result.push({
        name: 'Receipts Total',
        currency: currencySymbol,
        amount: totalreceipts,
        tabletype: 'sectiontotal',
    })

    result.push({
        name: 'Payments',
        tabletype: 'section',
    })

    let totalpayments = 0;
    generalledgerdata
        .filter(data => data.credit > 0)
        .map((data) => {
            let credit = 0;

            let date = moment.unix(data.ts).format("D/MMM/YYYY");

            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                credit = Number(data.credit) * rate || 0;
            }
            else {
                credit = Number(data.credit) || 0;
            }
            totalpayments = totalpayments + credit;
            result.push({
                date: date,
                name: data.name,
                accounttype: data.accounttype,
                currency: currencySymbol,
                amount: credit,
                tabletype: 'item',
            })
        })

    result.push({
        name: 'Payments Total',
        currency: currencySymbol,
        amount: totalpayments,
        tabletype: 'sectiontotal',
    })


    result.push({
        name: 'Net Total',
        currency: currencySymbol,
        amount: totalreceipts - totalpayments,
        tabletype: 'sectiontotal',
    })

    return result;
}

export function getprofitlossreportdata(context) {
    const {
        incomegroups,
        incomeaccounts,
        expensegroups,
        expenseaccounts,
        currencies,
        exchangerates,
        selectedcurrencyid,
        selectedsubaccountid,
        fromts,
        tots,
    } = context;

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)
        .filter(data => data.subaccountid == selectedsubaccountid || !selectedsubaccountid)

    let income = generalledgerdata
        .filter(data => data.accounttype == 'incomeaccounts')
    let expenses = generalledgerdata
        .filter(data => data.accounttype == 'expenseaccounts')

    const resultArray = [];
    const baseCurrencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    incomegroups.sort((a, b) => a.orderid - b.orderid);
    expensegroups.sort((a, b) => a.orderid - b.orderid);

    let incomegroupedsectiontotalactual = 0;
    let incomegroupedsectiontotalbudget = 0;
    let incomeungroupedsectiontotalactual = 0;
    let incomeungroupedsectiontotalbudget = 0;

    let expensegroupedsectiontotalactual = 0;
    let expensegroupedsectiontotalbudget = 0;
    let expenseungroupedsectiontotalactual = 0;
    let expenseungroupedsectiontotalbudget = 0;

    resultArray.push({
        name: "Income",
        tabletype: "section"
    });

    incomegroups.forEach((group) => {
        resultArray.push({
            name: group.name,
            tabletype: "group",
        });

        const groupedIncomeAccounts = incomeaccounts.filter((account) => account.groupid === group.id);
        let incomegroupedgrouptotalactual = 0;
        let incomegroupedgrouptotalbudget = 0;

        groupedIncomeAccounts.forEach((account) => {
            let filteredincome = income.filter(inc => inc.accountid == account.id)
            let credit = 0;

            filteredincome.forEach(entry => {
                if (entry.currencyid !== selectedcurrencyid) {
                    const groupNearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
                    const groupexchangerate = groupNearestExchangeRate.exchangerate;
                    credit = credit + parseFloat(entry.credit) * groupexchangerate;
                }
                else {
                    credit = credit + parseFloat(entry.credit)
                }
            });
            incomegroupedgrouptotalactual = incomegroupedgrouptotalactual + credit;

            resultArray.push({
                accountid: account.id,
                name: account.name,
                currency: baseCurrencySymbol,
                amount: credit,
                type: 'incomeaccounts',
                tabletype: "item",
            });
        });

        incomegroupedsectiontotalactual = incomegroupedsectiontotalactual + incomegroupedgrouptotalactual;
        incomegroupedsectiontotalbudget = incomegroupedsectiontotalbudget + incomegroupedgrouptotalbudget;

        resultArray.push({
            name: "Total - " + group.name,
            currency: baseCurrencySymbol,
            amount: incomegroupedgrouptotalactual,
            tabletype: "grouptotal",
        });
    });

    const ungroupedIncomeAccounts = incomeaccounts.filter((account) => !account.groupid);
    if (ungroupedIncomeAccounts.length) {
        let incomeungroupedgrouptotalactual = 0;
        let incomeungroupedgrouptotalbudget = 0;
        ungroupedIncomeAccounts.forEach((account) => {
            let filteredincome = income.filter(inc => inc.accountid == account.id)
            let credit = 0;

            filteredincome.forEach(entry => {
                if (entry.currencyid !== selectedcurrencyid) {
                    const groupNearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
                    const groupexchangerate = groupNearestExchangeRate.exchangerate;
                    credit = credit + parseFloat(entry.credit) * groupexchangerate;
                }
                else {
                    credit = credit + parseFloat(entry.credit)
                }
            });
            incomeungroupedsectiontotalactual = incomeungroupedsectiontotalactual + credit;

            resultArray.push({
                accountid: account.id,
                name: account.name,
                currency: baseCurrencySymbol,
                amount: credit,
                section: "income",
                type: 'incomeaccounts',
                tabletype: "item",
            });
        });

        incomegroupedsectiontotalactual = incomegroupedsectiontotalactual + incomeungroupedgrouptotalactual;
        incomegroupedsectiontotalbudget = incomegroupedsectiontotalbudget + incomeungroupedgrouptotalbudget;
    }

    let incomesectiontotalactual = incomegroupedsectiontotalactual + incomeungroupedsectiontotalactual;
    let incomesectiontotalbudget = incomegroupedsectiontotalbudget + incomeungroupedsectiontotalbudget;

    resultArray.push({
        name: "Total",
        currency: baseCurrencySymbol,
        amount: incomesectiontotalactual,
        section: "income",
        tabletype: "sectiontotal",
    });

    resultArray.push({
        name: "Expenses",
        tabletype: "section",
    });

    expensegroups.forEach((group) => {
        resultArray.push({
            name: group.name,
            tabletype: "group",
        });

        const groupedExpenseAccounts = expenseaccounts.filter((account) => account.groupid === group.id);
        let expensegroupedgrouptotalactual = 0;
        let expensegroupedgrouptotalbudget = 0;
        groupedExpenseAccounts.forEach((account) => {
            let filteredexpenses = expenses.filter(inc => inc.accountid == account.id)
            let debit = 0;

            filteredexpenses.forEach(entry => {
                if (entry.currencyid !== selectedcurrencyid) {
                    const groupNearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
                    const groupexchangerate = groupNearestExchangeRate.exchangerate;
                    debit = debit + parseFloat(entry.debit) * groupexchangerate;
                }
                else {
                    debit = debit + parseFloat(entry.debit)
                }
            });
            expensegroupedgrouptotalactual = expensegroupedgrouptotalactual + debit;

            resultArray.push({
                accountid: account.id,
                name: account.name,
                currency: baseCurrencySymbol,
                amount: debit,
                type: 'expenseaccounts',
                tabletype: "item",
            });
        });

        expensegroupedsectiontotalactual = expensegroupedsectiontotalactual + expensegroupedgrouptotalactual;
        expensegroupedsectiontotalbudget = expensegroupedsectiontotalbudget + expensegroupedgrouptotalbudget;

        resultArray.push({
            name: "Total - " + group.name,
            currency: baseCurrencySymbol,
            amount: expensegroupedgrouptotalactual,
            tabletype: "grouptotal",
        });
    });

    const ungroupedExpenseAccounts = expenseaccounts.filter((account) => !account.groupid);
    if (ungroupedExpenseAccounts.length) {
        let expenseungroupedgrouptotalactual = 0;
        let expenseungroupedgrouptotalbudget = 0;
        ungroupedExpenseAccounts.forEach((account) => {
            let filteredexpenses = expenses.filter(inc => inc.accountid == account.id)
            let debit = 0;

            filteredexpenses.forEach(entry => {
                if (entry.currencyid !== selectedcurrencyid) {
                    const groupNearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
                    const groupexchangerate = groupNearestExchangeRate.exchangerate;
                    debit = debit + parseFloat(entry.debit) * groupexchangerate;
                }
                else {
                    debit = debit + parseFloat(entry.debit)
                }
            });
            expenseungroupedgrouptotalactual = expenseungroupedgrouptotalactual + debit;

            resultArray.push({
                accountid: account.id,
                name: account.name,
                currency: baseCurrencySymbol,
                amount: debit,
                type: 'expenseaccounts',
                tabletype: "item",
            });
        });

        expensegroupedsectiontotalactual = expensegroupedsectiontotalactual + expenseungroupedgrouptotalactual;
        expensegroupedsectiontotalbudget = expensegroupedsectiontotalbudget + expenseungroupedgrouptotalbudget;
    }

    let expensesectiontotalactual = expensegroupedsectiontotalactual + expenseungroupedsectiontotalactual;
    let expensesectiontotalbudget = expensegroupedsectiontotalbudget + expenseungroupedsectiontotalbudget;

    resultArray.push({
        name: "Total",
        currency: baseCurrencySymbol,
        amount: expensesectiontotalactual,
        section: "expense",
        tabletype: "sectiontotal",
    });

    let netprofitactual = incomesectiontotalactual - expensesectiontotalactual;
    let netprofitbudget = incomesectiontotalbudget - expensesectiontotalbudget;

    resultArray.push({
        name: "Net Profit (Loss)",
        currency: baseCurrencySymbol,
        amount: netprofitactual,
        section: "group",
        tabletype: "sectiontotal",
    });

    return resultArray;
}

export function getClientBalances(context) {
    const {
        clients,
        transactions,
        journalentries,
        salesinvoices,
        subaccounts,
        fromts,
        tots,
        exchangerates,
        currencies,
        basecurrency
    } = context;

    const clientData = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)
        .filter(data => data.type == 'clients')

    clients.forEach((client) => {
        const clientSubaccounts = {};

        generalledgerdata.filter(data => data.accountid == client.id)

        transactions.forEach((transaction) => {
            if (transaction.from === client.id) {
                const subaccount = subaccounts.find((sub) => sub.id === transaction.subaccount);
                const subaccountName = subaccount ? subaccount.name : 'Default';
                const currency = currencies.find((currency) => currency.id === transaction.currencyid);
                const currencySymbol = currency ? currency.symbol : '';
                const amount = parseFloat(transaction.amount);
                clientSubaccounts[subaccountName] = {
                    balance: (clientSubaccounts[subaccountName]?.balance || 0) - amount,
                    currencySymbol: currencySymbol
                };
            }
        });

        journalentries.forEach((entry) => {
            entry.rows.forEach((row) => {
                if (row.accountid === client.id) {
                    const subaccount = subaccounts.find((sub) => sub.id === entry.subaccount);
                    const subaccountName = subaccount ? subaccount.name : 'Default';
                    const currency = currencies.find((currency) => currency.id === entry.currencyid);
                    const currencySymbol = currency ? currency.symbol : '';
                    const amount = parseFloat(row.debit) - parseFloat(row.credit);
                    clientSubaccounts[subaccountName] = {
                        balance: (clientSubaccounts[subaccountName]?.balance || 0) + amount,
                        currencySymbol: currencySymbol
                    };
                }
            });
        });

        salesinvoices.forEach((invoice) => {
            if (invoice.clientid == client.id) {
                const subaccount = subaccounts.find((sub) => sub.id === invoice.subaccount);
                const subaccountName = subaccount ? subaccount.name : 'Default';
                const currency = currencies.find((currency) => currency.id === invoice.currencyid);
                const currencySymbol = currency ? currency.symbol : '';
                const amount = parseFloat(invoice.amount);
                clientSubaccounts[subaccountName] = {
                    balance: (clientSubaccounts[subaccountName]?.balance || 0) + amount,
                    currencySymbol: currencySymbol
                };
            }
        });

        Object.entries(clientSubaccounts).forEach(([subaccountName, { balance, currencySymbol }]) => {
            clientData.push({
                clientname: client.name,
                subaccountname: subaccountName,
                balance: balance,
                currencysymbol: currencySymbol
            });
        });
    });

    clientData.sort((a, b) => a.clientname.localeCompare(b.clientname));

    return clientData;
}

export function getClientBalancesColumn(context) {
    const {
        clients,
        transactions,
        journalentries,
        salesinvoices,
        fromts,
        tots,
        subaccounts,
        currencies,
        exchangerates,
        basecurrency,
        order,
        zerobalances = false,
    } = context;

    const baseCurrencySymbol = currencies.find((currency) => currency.id === basecurrency)?.symbol;
    const result = {
        header: ["Name"],
        rows: [],
        footer: []
    };

    const clientData = [];
    const allSubaccountNames = new Set();

    clients.forEach((client) => {
        transactions.forEach((transaction) => {
            if (transaction.from === client.id) {
                const subaccount = subaccounts.find(sub => sub.id === transaction.subaccountid);
                if (subaccount) {
                    allSubaccountNames.add(subaccount);
                }
            }
        });
        journalentries.forEach((entry) => {
            entry.rows.forEach((row) => {
                if (row.accountid === client.id) {
                    const subaccount = subaccounts.find(sub => sub.id === entry.subaccountid);
                    if (subaccount) {
                        allSubaccountNames.add(subaccount);
                    }
                }
            });
        });

        salesinvoices.forEach((invoice) => {
            if (invoice.accountid === client.id) {
                const subaccount = subaccounts.find(sub => sub.id === invoice.subaccountid);
                if (subaccount) {
                    allSubaccountNames.add(subaccount);
                }
            }
        });
    });

    let totals = {};

    clients.forEach((client) => {
        const clientSubaccounts = {};

        transactions.forEach((transaction) => {
            if (transaction.ts >= fromts && transaction.ts <= tots) {
                if (transaction.from === client.id) {
                    const subaccount = subaccounts.find(sub => sub.id === transaction.subaccountid);
                    if (subaccount) {
                        const subaccountId = subaccount.id;
                        const subaccountCurrencyid = subaccount.currencyid;
                        const currencySymbol = currencies.find(currency => currency.id === subaccountCurrencyid)?.symbol;
                        const amount = parseFloat(transaction.amount);
                        if (subaccountCurrencyid === transaction.currencyid) {
                            clientSubaccounts[subaccountId] = {
                                balance: (clientSubaccounts[subaccountId]?.balance || 0) - amount,
                                currencyid: subaccountCurrencyid,
                                currencysymbol: currencySymbol,
                                subaccountid: subaccountId
                            };
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, subaccountCurrencyid);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            const convertedAmount = amount * exchangerate;
                            clientSubaccounts[subaccountId] = {
                                balance: (clientSubaccounts[subaccountId]?.balance || 0) - convertedAmount,
                                currencyid: subaccountCurrencyid,
                                currencysymbol: currencySymbol,
                                subaccountid: subaccountId
                            };
                        }
                    }
                }
            }
        });

        journalentries.forEach((entry) => {
            if (entry.ts >= fromts && entry.ts <= tots) {
                entry.rows.forEach((row) => {
                    if (row.accountid === client.id) {
                        const subaccount = subaccounts.find(sub => sub.id === entry.subaccountid);
                        if (subaccount) {
                            const subaccountId = subaccount.id;
                            const subaccountCurrencyid = subaccount.currencyid;
                            const currencySymbol = currencies.find(currency => currency.id === subaccountCurrencyid)?.symbol;
                            const amount = parseFloat(row.debit) - parseFloat(row.credit);
                            if (subaccountCurrencyid === entry.currencyid) {
                                clientSubaccounts[subaccountId] = {
                                    balance: (clientSubaccounts[subaccountId]?.balance || 0) + amount,
                                    currencyid: subaccountCurrencyid,
                                    currencysymbol: currencySymbol,
                                    subaccountid: subaccountId
                                };
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, subaccountCurrencyid);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedAmount = amount * exchangerate;
                                clientSubaccounts[subaccountId] = {
                                    balance: (clientSubaccounts[subaccountId]?.balance || 0) + convertedAmount,
                                    currencyid: subaccountCurrencyid,
                                    currencysymbol: currencySymbol,
                                    subaccountid: subaccountId
                                };
                            }
                        }
                    }
                });
            }
        });

        salesinvoices.forEach((invoice) => {
            if (invoice.ts >= fromts && invoice.ts <= tots) {
                if (invoice.clientid === client.id) {
                    const subaccount = subaccounts.find(sub => sub.id === invoice.subaccountid);
                    if (subaccount) {
                        const subaccountId = subaccount.id;
                        const subaccountCurrencyid = subaccount.currencyid;
                        const currencySymbol = currencies.find(currency => currency.id === subaccountCurrencyid)?.symbol;
                        const amount = parseFloat(invoice.amount);
                        if (subaccountCurrencyid === invoice.currencyid) {
                            clientSubaccounts[subaccountId] = {
                                balance: (clientSubaccounts[subaccountId]?.balance || 0) + amount,
                                currencyid: subaccountCurrencyid,
                                currencysymbol: currencySymbol,
                                subaccountid: subaccountId
                            };
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, subaccountCurrencyid);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            const convertedAmount = amount * exchangerate;
                            clientSubaccounts[subaccountId] = {
                                balance: (clientSubaccounts[subaccountId]?.balance || 0) + convertedAmount,
                                currencyid: subaccountCurrencyid,
                                currencysymbol: currencySymbol,
                                subaccountid: subaccountId
                            };
                        }
                    }
                }
            }
        });

        const columns = [client.name];
        let totalBalance = 0;

        allSubaccountNames.forEach((subaccountObject) => {
            const subaccount = clientSubaccounts[subaccountObject.id];
            const subaccountCurrencysymbol = currencies.find((currency) => currency.id === subaccountObject.currencyid)?.symbol;
            if (subaccount) {
                const balance = subaccount.balance;
                const currencySymbol = subaccount.currencysymbol;
                columns.push(currencySymbol + ' ' + parseFloat(balance.toFixed(2)));

                if (basecurrency === subaccount.currencyid) {
                    totalBalance += balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(exchangerates, 0, subaccount.currencyid, basecurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    totalBalance += balance * exchangerate;
                }
                totals[subaccountObject.name] = (totals[subaccountObject.name] || 0) + balance;
            }
            else {
                columns.push(subaccountCurrencysymbol + ' ' + 0);
            }
        });

        columns.push(baseCurrencySymbol + ' ' + parseFloat(totalBalance.toFixed(2)));
        totals["Total"] = (totals["Total"] || 0) + totalBalance;

        if (!zerobalances && totalBalance != 0) clientData.push({ clientname: client.name, columns: columns, totalbalance: totalBalance });
    });

    allSubaccountNames.forEach((subaccountObject) => {
        result.header.push(subaccountObject.name);
    });
    result.header.push("Total");

    if (order === "balanceasc") clientData.sort((a, b) => a.totalbalance - b.totalbalance);
    if (order === "balancedesc") clientData.sort((a, b) => b.totalbalance - a.totalbalance);
    if (order === "nameasc") clientData.sort((a, b) => naturalCompare(a.clientname, b.clientname));
    if (order === "namedesc") clientData.sort((a, b) => naturalCompare(b.clientname, a.clientname));

    result.rows = clientData;

    const footerRow = ["Total"];
    allSubaccountNames.forEach((subaccountObject) => {
        const currencySymbol = currencies.find((currency) => currency.id === subaccountObject.currencyid)?.symbol;
        const totalBalance = totals[subaccountObject.name] || 0;
        footerRow.push(currencySymbol + ' ' + parseFloat(totalBalance.toFixed(2)));
    });
    footerRow.push(baseCurrencySymbol + ' ' + parseFloat(totals["Total"]));

    result.footer = footerRow;

    return result;
}

export function getsalesinvoicesreportdata(context) {
    const {
        clients,
        subaccounts,
        currencies,
        exchangerates,
        selectedclientid,
        selectedcurrencyid,
        fromts,
        tots,
    } = context;

    let result = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)
        .filter(data => data.type == 'salesinvoices' && data.accounttype == 'clients')
        .filter(data => data.accountid == selectedclientid || !selectedclientid)

    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    let totalDebit = 0;

    for (let i = 0; i < generalledgerdata.length; i++) {
        const item = generalledgerdata[i];

        let debit = 0;

        let date = moment.unix(item.ts).format("D/MMM/YYYY");
        let accountname = clients.find(cl => cl.id == item.accountid)?.name
        let subaccountname = subaccounts.find(acc => acc.id == item.subaccountid)?.name

        if (item.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrencyid).exchangerate;
            debit = Number(item.debit) * rate || 0;
        }
        else {
            debit = Number(item.debit) || 0;
        }

        totalDebit = totalDebit + debit

        result.push({
            date: date,
            name: item.name,
            accounttype: item.accounttype,
            accountname: accountname,
            currency: currencySymbol,
            amount: debit,
            subaccount: subaccountname,
            tabletype: 'item',
        });
    }

    result.push({
        date: '',
        name: 'Total',
        accounttype: '',
        currency: currencySymbol,
        amount: totalDebit,
        tabletype: 'sectiontotal',
    });

    return result;
}

export function getpurchaseinvoicesreportdata(context) {
    const {
        suppliers,
        subaccounts,
        currencies,
        exchangerates,
        selectedsupplierid,
        selectedcurrencyid,
        fromts,
        tots,
    } = context;

    let result = [];

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(item => item.ts >= fromts && item.ts <= tots)
        .filter(data => data.type == 'purchaseinvoices' && data.accounttype == 'suppliers')
        .filter(data => data.accountid == selectedsupplierid || !selectedsupplierid)

    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    let totalCredit = 0;

    for (let i = 0; i < generalledgerdata.length; i++) {
        const item = generalledgerdata[i];

        let credit = 0;

        let date = moment.unix(item.ts).format("D/MMM/YYYY");
        let accountname = suppliers.find(su => su.id == item.accountid)?.name
        let subaccountname = subaccounts.find(acc => acc.id == item.subaccountid)?.name

        if (item.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrencyid).exchangerate;
            credit = Number(item.credit) * rate || 0;
        }
        else {
            credit = Number(item.credit) || 0;
        }

        totalCredit = totalCredit + credit

        result.push({
            date: date,
            name: item.name,
            accounttype: item.accounttype,
            accountname: accountname,
            currency: currencySymbol,
            amount: credit,
            subaccount: subaccountname,
            tabletype: 'item',
        });
    }

    result.push({
        date: '',
        name: 'Total',
        accounttype: '',
        currency: currencySymbol,
        amount: totalCredit,
        tabletype: 'sectiontotal',
    });

    return result;
}

export function getItemsQuantityData(context) {
    const {
        items,
        purchaseinvoices,
        salesinvoices,
        fromts,
        tots
    } = context;

    const resultArray = [];

    let totalpurchased = 0;
    let totalsold = 0;

    items.forEach(item => {
        let purchased = 0;
        let sold = 0;

        purchaseinvoices.forEach(invoice => {
            if (
                invoice.ts >= fromts &&
                invoice.ts <= tots &&
                invoice.items?.some(i => i.accountid === item.id)
            ) {
                invoice.items.forEach(i => {
                    if (i.accountid === item.id) {
                        let qty = parseFloat(i.itemquantity);
                        purchased += qty;
                    }
                });
            }
        });

        salesinvoices.forEach(invoice => {
            if (
                invoice.ts >= fromts &&
                invoice.ts <= tots &&
                invoice.items?.some(i => i.accountid === item.id)
            ) {
                invoice.items.forEach(i => {
                    if (i.accountid === item.id) {
                        let qty = parseFloat(i.itemquantity);
                        sold += qty;
                    }
                });
            }
        });

        totalpurchased += purchased;
        totalsold += sold;

        resultArray.push({
            type: 'account',
            id: item.id,
            code: item.code,
            name: item.name,
            purchased: purchased,
            sold: sold,
            remaining: purchased - sold,
            tabletype: 'item',
        });
    });

    resultArray.push({
        type: 'total',
        id: '',
        code: '',
        name: 'Total',
        purchased: totalpurchased,
        sold: totalsold,
        remaining: totalpurchased - totalsold,
        tabletype: 'sectiontotal',
    });

    return resultArray;
}

export function getItemsValueData(context) {
    const {
        items,
        purchaseinvoices,
        salesinvoices,
        fromts,
        tots,
        exchangerates,
        currencies,
        basecurrency
    } = context;

    const resultArray = [];
    const currencySymbol = currencies.find(c => c.id === basecurrency)?.symbol || '';

    const convertToBase = (amount, ts, currencyid) => {
        if (currencyid !== basecurrency) {
            const rate = findNearestExchangeRate(exchangerates, ts, currencyid, basecurrency)?.exchangerate || 1;
            return amount * rate;
        }
        return amount;
    };

    let totalpurchased = 0;
    let totalsold = 0;
    let totalprofit = 0;
    let totalmargin = 0;

    items.forEach(item => {
        let purchased = 0;
        let sold = 0;

        purchaseinvoices.forEach(invoice => {
            if (
                invoice.ts >= fromts &&
                invoice.ts <= tots &&
                invoice.items?.some(i => i.accountid === item.id)
            ) {
                invoice.items.forEach(i => {
                    if (i.accountid === item.id) {
                        const qty = parseFloat(i.itemquantity);
                        const unitCost = parseFloat(i.itemcost);
                        const total = qty * unitCost;
                        const converted = convertToBase(total, invoice.ts, invoice.currencyid);

                        purchased += converted;
                    }
                });
            }
        });

        salesinvoices.forEach(invoice => {
            if (
                invoice.ts >= fromts &&
                invoice.ts <= tots &&
                invoice.items?.some(i => i.accountid === item.id)
            ) {
                invoice.items.forEach(i => {
                    if (i.accountid === item.id) {
                        const qty = parseFloat(i.itemquantity);
                        const unitCost = parseFloat(i.itemprice);
                        const total = qty * unitCost;
                        const converted = convertToBase(total, invoice.ts, invoice.currencyid);

                        sold += converted;
                    }
                });
            }
        });

        let profit = sold - purchased;
        let margin = purchased > 0 ? ((profit / sold)) * 100 : 0;

        totalpurchased += purchased;
        totalsold += sold;
        totalprofit += profit;

        resultArray.push({
            type: 'account',
            id: item.id,
            code: item.code,
            name: item.name,
            purchased: purchased,
            sold: sold,
            profit: profit,
            margin: parseFloat(margin.toFixed(2)) + '%',
            currency: currencySymbol,
            tabletype: 'item',
        });
    });

    totalmargin = totalpurchased > 0 ? ((totalprofit / totalsold)) * 100 : 0;

    resultArray.push({
        type: 'total',
        id: '',
        code: '',
        name: 'Total',
        purchased: totalpurchased,
        sold: totalsold,
        profit: totalprofit,
        margin: parseFloat(totalmargin.toFixed(2)) + '%',
        currency: currencySymbol,
        tabletype: 'sectiontotal',
    });

    return resultArray;
}


export function getbalancesheetreportdata(context) {
    const {
        currencies,
        exchangerates,
        selectedcurrencyid,
        fromts,
        tots,
    } = context;

    let result = [];

    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    const assetaccounts = getAssetAccounts(context)
    const cashaccounts = getCashAccounts(context)
    const clientaccounts = getClientAccounts(context)
    const liabilityaccounts = getLiabilityAccounts(context)
    const supplieraccounts = getSupplierAccounts(context);
    const equityaccounts = getEquityAccounts(context)

    result.push({
        name: 'Assets',
        tabletype: 'section',
    });

    let totalassetaccounts = 0;
    assetaccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalassetaccounts = totalassetaccounts + balance
    })
    result.push({
        name: 'Fixed Assets',
        tabletype: 'item',
        amount: totalassetaccounts,
        currency: currencySymbol,
    });

    let totalcashaccounts = 0;
    cashaccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalcashaccounts = totalcashaccounts + balance
    })
    result.push({
        name: 'Cash Accounts',
        tabletype: 'item',
        amount: totalcashaccounts,
        currency: currencySymbol,
    });

    let totalclientaccounts = 0;
    clientaccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalclientaccounts = totalclientaccounts + balance
    })
    result.push({
        name: 'Receivables',
        tabletype: 'item',
        amount: totalclientaccounts,
        currency: currencySymbol,
    });

    result.push({
        name: 'Liabilities',
        tabletype: 'section',
    });

    let totalliabilityaccounts = 0;
    liabilityaccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalliabilityaccounts = totalliabilityaccounts + balance
    })
    result.push({
        name: 'Liabilities',
        tabletype: 'item',
        amount: totalliabilityaccounts,
        currency: currencySymbol,
    });

    let totalsupplieraccounts = 0;
    supplieraccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalsupplieraccounts = totalsupplieraccounts + balance
    })
    result.push({
        name: 'Suppliers',
        tabletype: 'item',
        amount: totalsupplieraccounts,
        currency: currencySymbol,
    });

    result.push({
        name: 'Equity',
        tabletype: 'section',
    });

    let totalequityaccounts = 0;
    equityaccounts.forEach(account => {
        let balance = parseFloat(account.balance) || 0;
        if (account.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, moment().unix(), account.currencyid, selectedcurrencyid).exchangerate;
            balance = balance * rate;
        }
        totalequityaccounts = totalequityaccounts + balance
    })
    result.push({
        name: 'Equity',
        tabletype: 'item',
        amount: totalequityaccounts,
        currency: currencySymbol,
    });

    return result;
}

export function getcashflowstatementdata(context) {//20250526
    const {
        expenseaccounts,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
        selectedcashaccountid,
        exchangerates,
        currencies,
    } = context;

    const resultArray = [];
    const currencySymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    let generalledgerdata = getGeneralLedgerData(context)
        .filter(data => data.accounttype == 'cashaccounts' && data.type != 'interaccounttransfers')
        .filter(data => data.subaccountid == selectedsubaccountid || !selectedsubaccountid)
        .filter(data => data.accountid == selectedcashaccountid || !selectedcashaccountid)

    resultArray.push({
        name: "Cash Inflows",
        currency: "",
        amount: "",
        tabletype: "section",
    });

    let inflowsoperating = 0;
    generalledgerdata
        .filter(data => data.activity == 'operating')
        .filter(data => data.debit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let debit = parseFloat(data.debit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                debit = debit * rate;
            }
            inflowsoperating = inflowsoperating + debit
        })
    resultArray.push({
        name: "Operating activities",
        currency: currencySymbol,
        amount: inflowsoperating,
        type: "receivables",
        tabletype: "item",
    });

    let inflowsfinancing = 0;
    generalledgerdata
        .filter(data => data.activity == 'financing')
        .filter(data => data.debit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let debit = parseFloat(data.debit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                debit = debit * rate;
            }
            inflowsfinancing = inflowsfinancing + debit
        })
    resultArray.push({
        name: "Financing activities",
        currency: currencySymbol,
        amount: inflowsfinancing,
        tabletype: "item",
    });

    let inflowsinvesting = 0;
    generalledgerdata
        .filter(data => data.activity == 'investing')
        .filter(data => data.debit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let debit = parseFloat(data.debit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                debit = debit * rate;
            }
            inflowsinvesting = inflowsinvesting + debit
        })
    resultArray.push({
        name: "Investing activities",
        currency: currencySymbol,
        amount: inflowsinvesting,
        tabletype: "item",
    });

    let totalinflows = inflowsoperating + inflowsfinancing + inflowsinvesting;
    resultArray.push({
        name: "Total Inflows",
        currency: currencySymbol,
        amount: totalinflows,
        tabletype: "sectiontotal",
    });

    resultArray.push({
        name: "Cash Outflows",
        currency: "",
        amount: "",
        tabletype: "section",
    });

    let outflowsoperating = 0;
    generalledgerdata
        .filter(data => data.activity == 'operating')
        .filter(data => data.credit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let credit = parseFloat(data.credit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                credit = credit * rate;
            }
            outflowsoperating = outflowsoperating + credit
        })
    resultArray.push({
        name: "Operating activities",
        currency: currencySymbol,
        amount: outflowsoperating,
        tabletype: "item",
    });

    let outflowsinvesting = 0;
    generalledgerdata
        .filter(data => data.activity == 'investing')
        .filter(data => data.credit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let credit = parseFloat(data.credit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                credit = credit * rate;
            }
            outflowsinvesting = outflowsinvesting + credit
        })
    resultArray.push({
        name: "Investing activities",
        currency: currencySymbol,
        amount: outflowsinvesting,
        tabletype: "item",
    });

    let outflowsfinancing = 0;
    generalledgerdata
        .filter(data => data.activity == 'financing')
        .filter(data => data.credit > 0)
        .filter(data => data.ts >= fromts)
        .map((data) => {
            let credit = parseFloat(data.credit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                credit = credit * rate;
            }
            outflowsfinancing = outflowsfinancing + credit
        })
    resultArray.push({
        name: "Financing activities",
        currency: currencySymbol,
        amount: outflowsfinancing,
        tabletype: "item",
    });

    let ungroupedsumexpense = 0;
    generalledgerdata
        .filter(data => data.activity != 'openingbalance')
        .filter(data => !data.fromid || !expenseaccounts.find(acc => acc.id == data.fromid))
        .filter(data => data.ts >= fromts)
        .forEach((data) => {
            let credit = parseFloat(data.credit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                credit = credit * rate;
            }
            ungroupedsumexpense = ungroupedsumexpense + credit
        });

    if (ungroupedsumexpense) resultArray.push({
        name: "Ungrouped expenses",
        currency: currencySymbol,
        amount: ungroupedsumexpense,
        tabletype: "item",
    });

    let totaloutflows = outflowsoperating + outflowsinvesting + outflowsfinancing + ungroupedsumexpense;
    resultArray.push({
        name: "Total Outflows",
        currency: currencySymbol,
        amount: totaloutflows,
        tabletype: "sectiontotal",
    });

    let cashAtBeginning = 0;
    generalledgerdata
        .filter(data => parseInt(data.ts) < parseInt(fromts) || data.activity == 'openingbalance')
        .map((data) => {
            let debit = parseFloat(data.debit) || 0;
            let credit = parseFloat(data.credit) || 0;
            if (data.currencyid !== selectedcurrencyid) {
                const rate = findNearestExchangeRate(exchangerates, data.ts, data.currencyid, selectedcurrencyid).exchangerate;
                debit = debit * rate;
                credit = credit * rate;
            }
            cashAtBeginning = cashAtBeginning - debit + credit;
        })

    const netChange = totalinflows - totaloutflows;
    const cashAtEnd = cashAtBeginning + netChange;

    if (netChange >= 0) {
        resultArray.push({
            name: "Net increase in cash",
            currency: currencySymbol,
            amount: netChange,
            tabletype: "sectiontotal",
        });
    }
    else {
        resultArray.push({
            name: "Net decrease in cash",
            currency: currencySymbol,
            amount: netChange,
            tabletype: "sectiontotal",
        });
    }

    resultArray.push({
        name: "Cash at beginning of the period",
        currency: currencySymbol,
        amount: cashAtBeginning,
        tabletype: "sectiontotal",
    });

    resultArray.push({
        name: "Cash at the end of the period",
        currency: currencySymbol,
        amount: cashAtEnd,
        tabletype: "sectiontotal",
    });

    return resultArray;
}


export function getClientBalancesRow(context) {
  const {
    clients,
    transactions,
    journalentries,
    fromts,
    tots,
    subaccounts,
    selectedcashaccountid,
    subaccountid,
    currencies,
    exchangerates,
    order
  } = context;

  const clientData = [];

  let generalledgerdata = getGeneralLedgerData(context)
    .filter(item => item.ts >= fromts && item.ts <= tots)
    .filter(data => data.accounttype == 'clients')
    .filter(data => data.accountid == selectedcashaccountid || !selectedcashaccountid)


  clients.forEach((client) => {
    const clientSubaccounts = {};
    const clientSubaccounts2 = {};

    let filtereddata = generalledgerdata.filter(item => item.accountid == client.id)
    filtereddata.forEach((item) => {
      clientSubaccounts2[item.subaccountid] = {
        balance:
          (clientSubaccounts2[item.subaccountid]?.balance || 0) - item.debit,
        currencySymbol: item.currencyid,
      };
    })

    transactions.forEach((transaction) => {
      if (transaction.ts >= fromts && transaction.ts <= tots) {
        if (transaction.from === client.id) {
          if (!subaccountid || transaction.subaccountid === subaccountid) {
            const subaccount = subaccounts.find(
              (sub) => sub.id === transaction.subaccountid
            );
            const subaccountName = subaccount ? subaccount.name : "Default";
            const subaccountCurrencyid = subaccount ? subaccount.currencyid : "";
            const currencySymbol = currencies.find((currency) => currency.id === subaccountCurrencyid)?.symbol;
            const amount = parseFloat(transaction.amount);
            if (subaccountCurrencyid === transaction.currencyid) {
              clientSubaccounts[subaccountName] = {
                balance:
                  (clientSubaccounts[subaccountName]?.balance || 0) - amount,
                currencySymbol: currencySymbol,
              };
            }
            else {
              const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, subaccountCurrencyid);
              const exchangerate = NearestExchangeRate.exchangerate;
              const convertedAmount =
                parseFloat(transaction.amount) * exchangerate;
              clientSubaccounts[subaccountName] = {
                balance: (clientSubaccounts[subaccountName]?.balance || 0) - convertedAmount, currencySymbol: currencySymbol,
              };
            }
          }
        }
      }
    });

    journalentries.forEach((entry) => {
      if (entry.ts >= fromts && entry.ts <= tots) {
        entry.rows.forEach((row) => {
          if (row.accountid === client.id) {
            if (!subaccountid || entry.subaccountid === subaccountid) {
              const subaccount = subaccounts.find(
                (sub) => sub.id === entry.subaccountid
              );
              const subaccountName = subaccount ? subaccount.name : "Default";
              const subaccountCurrencyid = subaccount
                ? subaccount.currencyid
                : "";
              const currencySymbol = currencies.find(
                (currency) => currency.id === subaccountCurrencyid
              )?.symbol;
              const amount = parseFloat(row.debit) - parseFloat(row.credit);
              if (subaccountCurrencyid === entry.currencyid) {
                clientSubaccounts[subaccountName] = {
                  balance:
                    (clientSubaccounts[subaccountName]?.balance || 0) + amount,
                  currencySymbol: currencySymbol,
                };
              } else {
                const NearestExchangeRate = findNearestExchangeRate(
                  exchangerates,
                  entry.ts,
                  entry.currencyid,
                  subaccountCurrencyid
                );
                const exchangerate = NearestExchangeRate.exchangerate;
                const convertedAmount = amount * exchangerate;
                clientSubaccounts[subaccountName] = {
                  balance:
                    (clientSubaccounts[subaccountName]?.balance || 0) +
                    convertedAmount,
                  currencySymbol: currencySymbol,
                };
              }
            }
          }
        });
      }
    });

    Object.entries(clientSubaccounts).forEach(
      ([subaccountName, { balance, currencySymbol }]) => {
        clientData.push({
          clientname: client.name,
          subaccountname: subaccountName,
          balance: balance,
          currencysymbol: currencySymbol,
        });
      }
    );
  });

  if (order === "balanceasc") clientData.sort((a, b) => a.balance - b.balance);
  if (order === "balancedesc") clientData.sort((a, b) => b.balance - a.balance);
  if (order === "nameasc") clientData.sort((a, b) => naturalCompare(a.clientname, b.clientname));
  if (order === "namedesc") clientData.sort((a, b) => naturalCompare(b.clientname, a.clientname));

  return clientData;
}


export function getSupplierAgingReport(context) {
  const {
    suppliers,
    transactions,
    purchaseinvoices,
    journalentries,
    exchangerates,
    currencies,
    basecurrency,
    selectedcashaccountid,
    fromts,
    tots,
  } = context;

  const data = [];
  const currencySymbol = currencies.find(item => item.id === basecurrency)?.symbol || '';
  const now = Math.floor(new Date().getTime() / 1000);

  let generalledgerdata = getGeneralLedgerData(context)
    .filter(item => item.ts >= fromts && item.ts <= tots)
    .filter(data => data.accounttype == 'suppliers')
    .filter(data => data.accountid == selectedcashaccountid || !selectedcashaccountid)

  suppliers.forEach((supplier) => {
    const aging = {
      thirty: 0,
      sixty: 0,
      ninety: 0,
      overninety: 0,
    };


    purchaseinvoices.forEach((invoice) => {
      if (invoice.supplierid === supplier.id) {
        let invoiceAmount = parseFloat(invoice.amount);
        if (invoice.currencyid !== basecurrency) {
          const nearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, basecurrency);
          const exchangeRate = nearestExchangeRate.exchangerate;
          invoiceAmount *= exchangeRate;
        }

        const ageInDays = Math.floor((now - invoice.ts) / (60 * 60 * 24));

        if (ageInDays <= 30) {
          aging.thirty += invoiceAmount;
        } else if (ageInDays <= 60) {
          aging.sixty += invoiceAmount;
        } else if (ageInDays <= 90) {
          aging.ninety += invoiceAmount;
        } else {
          aging.overninety += invoiceAmount;
        }
      }
    });

    journalentries.forEach((entry) => {
      if (entry.rows) {
        entry.rows.forEach((row) => {
          if (row.accountid === supplier.id) {
            let rowAmount = parseFloat(row.debit - row.credit);
            if (entry.currencyid !== basecurrency) {
              const nearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, basecurrency);
              const exchangeRate = nearestExchangeRate.exchangerate;
              rowAmount *= exchangeRate;
            }

            const ageInDays = Math.floor((now - entry.ts) / (60 * 60 * 24));

            if (ageInDays <= 30) {
              aging.thirty += rowAmount;
            } else if (ageInDays <= 60) {
              aging.sixty += rowAmount;
            } else if (ageInDays <= 90) {
              aging.ninety += rowAmount;
            } else {
              aging.overninety += rowAmount;
            }
          }
        });
      }
    });

    transactions.forEach((transaction) => {
      if (transaction.beneficiaryid === supplier.id) {
        let transactionAmount = parseFloat(transaction.amount);
        if (transaction.currencyid !== basecurrency) {
          const nearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, basecurrency);
          transactionAmount *= nearestExchangeRate.exchangerate;
        }

        if (transactionAmount > 0) {
          if (aging.overninety > 0) {
            const amountToDeduct = Math.min(aging.overninety, transactionAmount);
            aging.overninety -= amountToDeduct;
            transactionAmount -= amountToDeduct;
          }

          if (transactionAmount > 0 && aging.ninety > 0) {
            const amountToDeduct = Math.min(aging.ninety, transactionAmount);
            aging.ninety -= amountToDeduct;
            transactionAmount -= amountToDeduct;
          }

          if (transactionAmount > 0 && aging.sixty > 0) {
            const amountToDeduct = Math.min(aging.sixty, transactionAmount);
            aging.sixty -= amountToDeduct;
            transactionAmount -= amountToDeduct;
          }

          if (transactionAmount > 0 && aging.thirty > 0) {
            const amountToDeduct = Math.min(aging.thirty, transactionAmount);
            aging.thirty -= amountToDeduct;
            transactionAmount -= amountToDeduct;
          }
        }
      }
    });

    data.push({
      id: supplier.id,
      name: supplier.name,
      currency: currencySymbol,
      aging: {
        thirty: aging.thirty.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        sixty: aging.sixty.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        ninety: aging.ninety.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        overninety: aging.overninety.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      }
    });
  });

  data.sort((a, b) => {
    const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
    if (nameComparison === 0) {
      return parseFloat(a.balance) - parseFloat(b.balance);
    }
    return nameComparison;
  });

  return data;
}